// extracted by mini-css-extract-plugin
export var apiV2ContractChange = "api-v2-contract-change_s8RTpZwpGUMEkNGeA3OW";
export var apiV2ContractChangeForm = "api-v2-contract-change__form_LhfD4mI84c5F93wNeXhX";
export var apiV2ContractChangeFormContent = "api-v2-contract-change__form-content_COAg_Wa5_1ENdw5qokBK";
export var apiV2ContractChangeHandle = "api-v2-contract-change__handle_ujo0coCwcQ_6kqxAf5rp";